import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { isEmpty } from 'validate.js';

import SmartImage from 'dpl/components/SmartImage';

export default function ReviewsPhotos({ className, photographs, imageSize }) {
  if (isEmpty(photographs)) return null;

  // Reverse the order of photos so that the first photo in the array is on top
  const photos = [...photographs].reverse();

  return (
    <ul
      className={classnames(
        'ReviewsPhotos flex',
        {
          // Offset negative top margin on second photo
          pt1: photographs.length > 1
        },
        className
      )}
      style={{ '--image-size': imageSize }}
    >
      {photos.map((photograph, index) => (
        <li
          key={photograph.id}
          className={classnames(
            'ReviewsPhotos__item ba b--white br2 br3-ns overflow-hidden',
            `ReviewsPhotos__item--${photographs.length - index}`
          )}
        >
          <SmartImage
            Tag="div"
            className="w-100 h-100 cover bg-center"
            src={photograph.url}
            loadingClass="bg-light-gray"
            crop
            lazy
          />
        </li>
      ))}
    </ul>
  );
}

ReviewsPhotos.propTypes = {
  className: PropTypes.string,
  imageSize: PropTypes.string,
  photographs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      url: PropTypes.string.isRequired
    })
  ).isRequired
};

ReviewsPhotos.defaultProps = {
  className: null,
  imageSize: '40px'
};
